import { RefObject, useEffect, useMemo } from 'react'
import { getRefElement } from 'utils/getRefElement'

interface Props {
  target?: RefObject<Element> | Element | Node | null
  options?: MutationObserverInit
  callback?: MutationCallback
}

export const useMutationObserver = ({ target, options = {}, callback }: Props): void => {
  const observer = useMemo(
    () =>
      typeof window !== 'undefined'
        ? new MutationObserver((mutationRecord, mutationObserver) => {
            callback?.(mutationRecord, mutationObserver)
          })
        : null,
    [callback]
  )

  useEffect(() => {
    const element = getRefElement(target)

    if (observer && element) {
      observer.observe(element, options)
      return () => observer.disconnect()
    }
  }, [target, observer, options])
}
